/* eslint-disable no-underscore-dangle */
import { useState, useContext } from 'react';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { STORE_FIELDS } from './storeFormFields';
import { validateStoreData } from './storeFormValidation';

export function useStoreForm() {
  const { setErrorMessage, setInfoMessage } = useContext(GeneralContext);
  const {
    NAME,
    STREET,
    CITY,
    STATE,
    ZIP_CODE,
    WEBSITE_URL,
    MONTHLY_ORDERS,
    TIME_ZONE,
    NUMBER,
    ADDR_DISTRICT,
    EMAIL,
    TELEPHONE,
    CNPJ,
    COMPLEMENT,
  } = STORE_FIELDS;
  const [formState, setFormState] = useState({
    [NAME]: '',
    [CNPJ]: '',
    [WEBSITE_URL]: '',
    [MONTHLY_ORDERS]: '',
    [TIME_ZONE]: '',
    [EMAIL]: '',
    [TELEPHONE]: '',
    [COMPLEMENT]: '',
    [NUMBER]: '',
    [ADDR_DISTRICT]: '',
    [STREET]: '',
    [CITY]: '',
    [STATE]: '',
    [ZIP_CODE]: '',
  });
  const [formError, setFormError] = useState({
    [NAME]: false,
    [CNPJ]: false,
    [WEBSITE_URL]: false,
    [MONTHLY_ORDERS]: false,
    [TIME_ZONE]: false,
    [EMAIL]: false,
    [TELEPHONE]: false,
    [STREET]: false,
    [COMPLEMENT]: false,
    [NUMBER]: false,
    [ADDR_DISTRICT]: false,
    [CITY]: false,
    [STATE]: false,
    [ZIP_CODE]: false,
  });
  const [initialFormState, setInitialFormState] = useState({
    [NAME]: '',
    [CNPJ]: '',
    [WEBSITE_URL]: '',
    [MONTHLY_ORDERS]: '',
    [TIME_ZONE]: '',
    [EMAIL]: '',
    [TELEPHONE]: '',
    [COMPLEMENT]: '',
    [NUMBER]: '',
    [ADDR_DISTRICT]: '',
    [STREET]: '',
    [CITY]: '',
    [STATE]: '',
    [ZIP_CODE]: '',
  });

  function resetForm() {
    setFormState(initialFormState);
    setInfoMessage('Alterações descartadas com sucesso');
  }

  function validateForm() {
    const { isValid, errors } = validateStoreData(formState);
    setFormError(errors);
    if (!isValid) {
      setErrorMessage('Preencha todos os campos obrigatórios.');
    }
    return isValid;
  }

  function mapStoreToFormState(store) {
    const fetchedData = {
      [NAME]: store[NAME],
      [CNPJ]: store[CNPJ],
      [WEBSITE_URL]: store[WEBSITE_URL],
      [MONTHLY_ORDERS]: store[MONTHLY_ORDERS],
      [TIME_ZONE]: store[TIME_ZONE],
      [EMAIL]: store[EMAIL],
      [TELEPHONE]: store[TELEPHONE],
      [STREET]: store.address ? store.address.street : '',
      [COMPLEMENT]: store.address ? store.address.complement : '',
      [ADDR_DISTRICT]: store.address ? store.address.district : '',
      [NUMBER]: store.address ? store.address.number : '',
      [CITY]: store.address ? store.address.city : '',
      [STATE]: store.address ? store.address.state : '',
      [ZIP_CODE]: store.address ? store.address.zipCode : '',
    };
    setFormState(fetchedData);
    setInitialFormState(fetchedData);
  }

  function cleanFormState(store) {
    const fetchedData = {
      [NAME]: store[NAME],
      [CNPJ]: store[CNPJ],
      [WEBSITE_URL]: store[WEBSITE_URL],
      [MONTHLY_ORDERS]: store[MONTHLY_ORDERS],
      [TIME_ZONE]: store[TIME_ZONE],
      [EMAIL]: store[EMAIL],
      [TELEPHONE]: store[TELEPHONE],
      [STREET]: store[STREET],
      [COMPLEMENT]: store[COMPLEMENT],
      [ADDR_DISTRICT]: store[ADDR_DISTRICT],
      [NUMBER]: store[NUMBER],
      [CITY]: store[CITY],
      [STATE]: store[STATE],
      [ZIP_CODE]: store[ZIP_CODE],
    };
    setFormState(fetchedData);
  }

  return {
    formState,
    setFormState,
    formError,
    setFormError,
    setInitialFormState,
    resetForm,
    validateForm,
    mapStoreToFormState,
    cleanFormState,
  };
}
